// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__trTdu","question":"styles_question__1IbhS","description":"styles_description__1Tqb0"};